import { createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../models/base';

export const fetchStats = createAsyncThunk(
  'analytics/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await get('/api/stats');
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
